
import { Component, Vue } from "vue-property-decorator";
import { MedicalOrderService ,rightsService, EmployerActivityService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { Pay, tools } from "src/utils";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 数据模型
     * @private
     * @returns any
     */
    private dataModel: any =
    {
        isNeedAppointment: true,
        marketPrice: null,
        price:null,
        productId: null,
        productName: "",
        productPict: "",
        productTypeStr:"",
        supplierId: null,
        supplierLogo:"",
        supplierName:"",
    };

    /**
     * 选择优惠券
     * @protected
     * @returns boolean
     */
     protected showCouponPopup: boolean = false;

    /**
     * 优惠券信息
     * @private
     * @returns any
     */
    private couponInfo: any =
    {
        finalReduceAmount: null,
        finalAmount: null,
        couponId: null,
    };

    /**
     * 可用优惠券列表
     * @private
     * @returns any
     */
    private couponList: any = [];

    /**
     * 卡片信息
     * @private
     * @returns any
     */
     private cardInfo: any = {
        orderId: 0,
        rightsMemberName: "",
        memberId: 0,
        memberName: "",
        phone: "",
        cardNo: "",
        rightsId: 0,
        rightsName: "",
        backgroundColor: "",
        rightsDesc: "",
        activedLimitTime: "",
        activedLimitTimeStr: "",
        activedEffTime: "",
        activedEffTimeStr: ""
    };

    /**
     * 商品详情id
     * @private
     * @returns string
     */
    private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 产品id
     * @private
     * @returns string
     */
    private get productId(): string
    {
        return this.$route.query && (this.$route.query.productId as string) || "";
    }

    /**
     * 权益id
     * @private
     * @returns string
     */
     private get rightsId(): string
    {
        return this.$route.query && (this.$route.query.rightsId as string) || "";
    }
    
    /**
     * 组件创建钩子
     * @protected
     * @returns void
     */
    protected created()
    {
        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        this.getPreMedicalOrderInfo(this.id);
        this.$nextTick(() => {
            if (this.rightsId)
            {
                this.getCardByMemberRightId();
            }
        })
    }

    /**
     * 获取订单列表
     * @private
     * @returns void
     */
     private async getCardByMemberRightId(): Promise<void>
    {
        try
        {
            let { content: result } = await rightsService.instance.clientGetCardByMemberRightId(this.rightsId);
            if(result.data)
            {
                this.cardInfo = result.data;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 获取产品下单前数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getPreMedicalOrderInfo(id: string): Promise<void>
    {
        try
        {
            const isRights = this.rightsId ? true : null;
            let {content: result} = await MedicalOrderService.instance.getPreMedicalOrderInfo(id,isRights);

            if(result.data)
            {
                this.dataModel = result.data;
                this.productId && this.getCouponSuitable();
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 获取优惠券列表
     * @private
     * @returns void
     */
     private async getCouponSuitable(): Promise<void>
    {
        try
        {
            let params = {
                id: this.productId,
                amount: this.dataModel.price
            };
            let {content: result} =  await EmployerActivityService.instance.couponSuitable(params);

            if(result.data)
            {
                this.couponList = result.data;
                this.couponInfo = result.data[0] || {};
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 提交订单
     * @public
     * @param {params}
     */
    public async onSubmit(): Promise<void>
    {
        try
        {
            let params = {
                productId: this.id, // 此处productId为home组件列表接口返回的targetId, 是从供应商拉取产品最初的id，列表接口中的id为重组之后的id，作为productId路由参数传到此页面，此注释为澄清，避免两个id混淆
                rightsId: this.rightsId,
                couponId: this.couponInfo.couponId || null,
            };
            let {content: result} = await MedicalOrderService.instance.createMedicalOrder(params);
            
            if(result.data)
            {

                if(result.data.isNeedPay)
                {
                    // 需要支付
                    // Pay.onBridgeReady(result.data,
                    //     ()=> this.onSucessDetail(result.data.orderId), 
                    //     ()=> this.onActionOrderDetail(result.data.orderId)
                    // )
                    this.$router.push({name: "pay", query:{orderNo: result.data.orderNo}});
                }
                else
                {
                    this.$router.push({name: "medical-order-sucess", query:{id: result.data.orderId, productCategory: result.data.productCategory}});
                }
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 跳转成功页面
     * @private
     * @returns void
     */
     private onSucessDetail(id: string): void
    {
        this.$router.push({name: "medical-order-sucess", query:{id: id}});
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(id: string): void
    {
        this.$router.push({name: "medical-order-detail", query:{id: id}});
    }

    /**
     * 确认切换优惠券
     * @private
     * @returns void
     */
    protected onConfirmCoupon(data: any): void
    {
        if (data) {
            this.couponInfo = data;
        }
        else {
            this.couponInfo = {
                finalReduceAmount: null,
                finalAmount: null,
                couponId: null,
            };
        }
        this.showCouponPopup = false;
    }

}
